import 'angular:locale/data:sv';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
